// Modal for moving a deal to a different workspace. Lists the user's other
// workspaces and calls handleMoveTransaction on confirm. There is no
// create-a-team path here: team creation keeps its one entry point in the
// workspace switcher.

import React from 'react';
import { Modal, Button, Field, Select } from '../primitives';

function MoveTransactionModal({ workspaces, onClose, onMove }) {
    const [targetId, setTargetId] = React.useState(workspaces[0]?.id || '');
    const [submitting, setSubmitting] = React.useState(false);
    const mountedRef = React.useRef(true);

    React.useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, []);

    const submit = async () => {
        if (!targetId || submitting) return;
        setSubmitting(true);
        try {
            await onMove(targetId);
        } finally {
            // App.js unmounts the modal on success, so only clear while mounted.
            if (mountedRef.current) setSubmitting(false);
        }
    };

    return (
        <Modal
            title="Move to workspace"
            onClose={onClose}
            maxWidth={400}
            footer={(
                <>
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="primary" onClick={submit} disabled={submitting || !targetId}>Move</Button>
                </>
            )}
        >
            <Field label="Workspace">
                <Select value={targetId} onChange={(e) => setTargetId(e.target.value)}>
                    {workspaces.map((ws) => <option key={ws.id} value={ws.id}>{ws.name}</option>)}
                </Select>
            </Field>
        </Modal>
    );
}

export default MoveTransactionModal;
